import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  previewAvatar: FelaCSS;
  title: FelaCSS;
  tagWrapper: FelaCSS;
  quote: FelaCSS;
  description: FelaCSS;
  avatarWrapper: FelaCSS;
  tag: FelaCSS;
  button: FelaCSS;
  image: FelaCSS;
  wrapper: FelaCSS;
}
const styles = (): IStyles => ({
  wrapper: {
    marginBottom: 8,
    marginHorizontal: 4,
    desktopDesign: {
      marginHorizontal: 0,
      marginBottom: 10,
    },
    maxWidthTablet: {
      marginHorizontal: 4,
    },
  },
  previewAvatar: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    backgroundColor: colors.blueCrush30,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontDefaultSemiBold: 22,
    lineHeight: '120%',
    paddingVertical: 4,
    wordBreak: 'break-word',
    textAlign: 'center',
    desktopDesign: {
      fontDefaultSemiBold: 28,
    },
  },
  image: {
    borderRadius: '50%',
  },
  tagWrapper: {
    flexWrap: 'wrap',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  quote: {
    lineHeight: '150%',
    fontDefaultLight: 18,
    color: colors.space,
    textAlign: 'center',
    wordBreak: 'break-word',
    desktopDesign: {
      fontDefault: 24,
    },
    paddingTop: 10,
  },
  description: {
    paddingTop: 10,
    fontDefault: 14,
    lineHeight: '150%',
    wordBreak: 'break-word',
    color: colors.space75,
    desktopDesign: {
      fontDefault: 16,
    },
  },
  avatarWrapper: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    backgroundColor: colors.white,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: colors.space04,
    justifyContent: 'center',
    marginTop: 4,
  },
  tag: {
    backgroundColor: colors.blueCrush10,
    paddingVertical: 2,
    paddingHorizontal: 4,
    fontDefault: 14,
    borderRadius: 4,
    lineHeight: '150%',
    desktopDesign: {
      fontDefault: 16,
    },
  },
  button: {
    alignSelf: 'flex-start',
    marginTop: 2,
  },
});

export default styles;
